import { FC } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import convertLinksToAnchors from '@helpers/convertLinksToAnchors';
import convertEmailsToAnchors from '@helpers/convertEmailsToAnchors';

import s from './RenderText.module.scss';

const ALLOWED_ATTR = ['target', 'rel', 'href', 'src'];

type TextProps = {
  comment: {
    text?: string | null;
    richText?: {
      html: string;
    } | null
  } | null
};

const RenderText: FC<TextProps> = ({ comment }) => {
  let message = comment?.richText?.html || comment?.text || '';

  if (!message) {
    return null;
  }

  message = convertLinksToAnchors(message);
  message = convertEmailsToAnchors(message);
  message = message.replace(/\n/g, '<p></p>');

  return (
    <div
      className={s.text}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message, { ALLOWED_ATTR }) }}
    />
  );
};

export default RenderText;
